import * as Yup from 'yup';
import { emailRegEx, phoneRegEx, zipCodeRegEx } from '@/utils/RegularExpressions';
import { States } from '../../../../../constants';

export const validStateOptions: string[] = States.map((state) => state.name);

export const defaultStepsSchema = Yup.object({
  applicantInformation: Yup.object({
    fullName: Yup.string().required('Required').max(250, 'Must be less than 250 characters.'),
    contactEmail: Yup.string().required('Required').matches(emailRegEx, 'Please enter a valid email address'),
  }),
});

export const step1Schema = Yup.object({
  application: Yup.object({
    name: Yup.string().required('Required').min(4, 'It must be greater than 4 character'),
    streetAddress: Yup.string().required('Required').min(4, 'It must be greater than 4 character'),
    city: Yup.string().required('Required').min(2, 'It must be greater than 2 character'),
    state: Yup.string().required('Required').oneOf(validStateOptions, 'Invalid option'),
    zipCode: Yup.string()
      .required('Required')
      .matches(zipCodeRegEx, 'It must be 5 digits')
      .max(5, 'It must be 5 digits')
      .min(5, 'It must be 5 digits'),
    homePhone: Yup.string().matches(phoneRegEx, {
      excludeEmptyString: true,
      message: 'Please enter a valid phone number',
    }),
    workPhone: Yup.string().required('Required').matches(phoneRegEx, {
      excludeEmptyString: true,
      message: 'Please enter a valid phone number',
    }),
    otherPhone: Yup.string().required('Required').matches(phoneRegEx, {
      excludeEmptyString: true,
      message: 'Please enter a valid phone number',
    }),
    dob: Yup.string().required('Required'),
    lastFourSocial: Yup.string()
      .required('Required')
      .matches(/^\d{4}([-]|\s*)?(\d{4})?$/gm, 'It must be 4 digits')
      .max(4, 'It must be 4 digits')
      .min(4, 'It must be 4 digits'),
    gender: Yup.string().required('Required'),
    maritalStatus: Yup.string().required('Required'),
    disabled: Yup.string().required('Required'),
    desiredBedrooms: Yup.string().required('Required'),
    races: Yup.array().min(1, 'Required').typeError('Required'),
    incomeSources: Yup.object({
      wages: Yup.number()
        .typeError('Must be a number')
        .min(0, 'Must be a positive number or 0')
        .transform((val) => (Number.isNaN(val) ? 0 : val))
        .required('Required'),
      pension: Yup.number()
        .typeError('Must be a number')
        .min(0, 'Must be a positive number or 0')
        .transform((val) => (Number.isNaN(val) ? 0 : val))
        .required('Required'),
      publicAssistance: Yup.number()
        .typeError('Must be a number')
        .min(0, 'Must be a positive number or 0')
        .transform((val) => (Number.isNaN(val) ? 0 : val))
        .required('Required'),
      ssi: Yup.number()
        .typeError('Must be a number')
        .min(0, 'Must be a positive number or 0')
        .transform((val) => (Number.isNaN(val) ? 0 : val))
        .required('Required'),
      other: Yup.number()
        .typeError('Must be a number')
        .min(0, 'Must be a positive number or 0')
        .transform((val) => (Number.isNaN(val) ? 0 : val))
        .required('Required'),
    }),
  }),
});

export const step2Schema = Yup.object({
  householdIncome: Yup.array(),
});

export const fakeSchema = Yup.object();

export const BDPAValidationSchema = {
  defaultStepsSchema,
  step1Schema,
  step2Schema,
};
